import {
  CreactePlanBegin,
  CreatePlanSuccess,
  CreatePlanFailure,
  FetchPlanBegin,
  FetchPlanSuccess,
  FetchPlanFailure,
  FetchPlansAnswersBegin,
  FetchPlansAnswersSuccess,
  FetchPlansAnswersFailure,
  SaveAboutMeBegin,
  SaveAboutMeSuccess,
  SaveAboutMeFailure,
  SaveSupportTeamBegin,
  SaveSupportTeamSuccess,
  SaveSupportTeamFailure,
  SaveCommunityActiviesBegin,
  SaveCommunityActiviesSuccess,
  SaveCommunityActiviesFailure,
  SaveMyGoalsBegin,
  SaveMyGoalsSuccess,
  SaveMyGoalsFailure,
  SaveRequiredServicesBegin,
  SaveRequiredServicesSuccess,
  SaveRequiredServicesFailure,
  DeleteSupportTeamBegin,
  DeleteSupportTeamSuccess,
  DeleteSupportTeamFailure,
  DeleteRequiredServicesBegin,
  DeleteRequiredServicesSuccess,
  DeleteRequiredServicesFailure,
  FileUploadBegin,
  FileUploadSuccess,
  FileUploadFailure,
  FetchSupportRequestBegin,
  FetchSupportRequestSuccess,
  FetchSupportRequestFailure,
  SaveSupportRequestBegin,
  SaveSupportRequestSuccess,
  SaveSupportRequestFailure,
  ToggleEndorsementBegin,
  ToggleEndorsementSuccess,
  ToggleEndorsementFailure,
  ArchiveSuggestionsBegin,
  ArchiveSuggestionsSuccess,
  ArchiveSuggestionsFailure
} from "./actions"
import configs from "../../configs"

const getDate = () => {
  const dateObj = new Date()
  const month = String(dateObj.getMonth() + 1).padStart(2, "0")
  const day = String(dateObj.getDate()).padStart(2, "0")
  const year = dateObj.getFullYear()

  return `${day}-${month}-${year}`
}

const fetchAboutUs = (token, planId) => {
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  })

  return fetch(`${configs.api.base}/api/user/plans/about-me/${planId}/`, {
    method: "GET",
    headers
  })
}

const fetchSupportTeam = (token, planId) => {
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  })

  return fetch(
    `${configs.api.base}/api/participant/plans/guardians/${planId}/list/`,
    {
      method: "GET",
      headers
    }
  )
}

const fetchCommunityActivities = (token, planId) => {
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  })

  return fetch(
    `${configs.api.base}/api/user/plans/organised-community/${planId}/`,
    {
      method: "GET",
      headers
    }
  )
}

const fetchMyGoals = (token, planId) => {
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  })

  return fetch(`${configs.api.base}/api/user/plans/my-goal/${planId}/`, {
    method: "GET",
    headers
  })
}

const fetchRequiredServices = (token, planId) => {
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  })

  return fetch(
    `${configs.api.base}/api/user/plan/unclassified-notes/${planId}/`,
    {
      method: "GET",
      headers
    }
  )
}

export const fetchPlansAnswers = (token, planId) => {
  return dispatch => {
    dispatch(FetchPlansAnswersBegin())

    return new Promise((resolve, reject) => {
      Promise.allSettled([
        fetchAboutUs(token, planId),
        fetchSupportTeam(token, planId),
        fetchCommunityActivities(token, planId),
        fetchMyGoals(token, planId),
        fetchRequiredServices(token, planId)
      ])
        .then(responses => {
          return Promise.all(
            responses.map(r => {
              if (r.status === "fulfilled" && r.value.status === 200) {
                return r.value.json()
              }
              return {}
            })
          )
        })
        .then(
          ([
            aboutMe,
            supportTeam,
            communityActivities,
            myGoals,
            requiredServices
          ]) => {
            const answers = {
              aboutMe,
              supportTeam,
              communityActivities,
              myGoals,
              requiredServices: requiredServices.unclassified_note
            }

            dispatch(FetchPlansAnswersSuccess(answers))
            resolve(answers)
          }
        )
        .catch(e => {
          dispatch(FetchPlansAnswersFailure(e))
          reject(e)
        })
    })
  }
}

export const createPlan = token => {
  return dispatch => {
    dispatch(CreactePlanBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/participant/plans/`, {
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify({ name: `Plan ${getDate()}` })
      })
        .then(response => {
          if (response.status === 201) {
            return response.json()
          }
          dispatch(CreatePlanFailure())
          reject()
          return null
        })
        .then(data => {
          if (data) {
            dispatch(CreatePlanSuccess(data.PlanId))
            dispatch(fetchPlansAnswers(token, data.PlanId))
            resolve()
          }
        })
    })
  }
}

export const fetchPlan = token => {
  return dispatch => {
    dispatch(FetchPlanBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/participant/plans/?page=1&page_size=20`, {
        method: "GET",
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        })
      })
        .then(response => {
          if (response.status === 200) {
            return response.json()
          }

          dispatch(FetchPlanFailure())
          reject()
          return null
        })
        .then(data => {
          if (data && data.count) {
            dispatch(FetchPlanSuccess(data.results[0].id))
            resolve(data.results[0].id)
          } else {
            dispatch(FetchPlanFailure())
            reject()
          }
        })
        .catch(e => {
          dispatch(FetchPlanFailure(e))
          reject(e)
        })
    })
  }
}

export const saveAboutMe = (token, planId, body) => {
  return dispatch => {
    dispatch(SaveAboutMeBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/user/plans/about-me/${planId}/`, {
        method: "PUT",
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(body)
      })
        .then(response => {
          if (response.status === 200) {
            response.json().then(data => {
              resolve()
              dispatch(SaveAboutMeSuccess(data))
            })
          } else {
            dispatch(SaveAboutMeFailure())
            reject()
          }
        })
        .catch(e => {
          dispatch(SaveAboutMeFailure(e))
          reject(e)
        })
    })
  }
}

export const saveSupportTeam = (token, memberId, member, type, planId) => {
  return dispatch => {
    dispatch(SaveSupportTeamBegin())

    let url
    let method
    const body = member

    if (type === "edit") {
      method = "PUT"
      url = `${configs.api.base}/api/participant/plans/guardians/${memberId}/`
    } else if (type === "add") {
      body.guardian_id = memberId
      method = "POST"
      url = `${configs.api.base}/api/participant/plans/add-guardian/`
    }

    return new Promise((resolve, reject) => {
      fetch(url, {
        method,
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(body)
      })
        .then(response => {
          if (response.status === 200) {
            fetchSupportTeam(token, planId)
              .then(response2 => {
                if (response2.status === 200) {
                  return response2.json()
                }
                dispatch(SaveSupportTeamFailure())
                reject()
                return null
              })
              .then(data => {
                if (data) {
                  dispatch(SaveSupportTeamSuccess(data))
                  resolve()
                }
              })
              .catch(e => {
                dispatch(SaveSupportTeamFailure(e))
                reject()
              })
          } else {
            response.json().then(message => {
              dispatch(SaveSupportTeamFailure())
              reject(message)
            })
          }
        })
        .catch(e => {
          dispatch(SaveSupportTeamFailure(e))
          reject(e)
        })
    })
  }
}

export const saveCommunityActivities = (token, planId, activities) => {
  return dispatch => {
    dispatch(SaveCommunityActiviesBegin())

    return new Promise((resolve, reject) => {
      fetch(
        `${configs.api.base}/api/user/plans/organised-community/${planId}/`,
        {
          method: "PUT",
          headers: new Headers({
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }),
          body: JSON.stringify(activities)
        }
      )
        .then(response => {
          if (response.status === 201) {
            fetchCommunityActivities(token, planId)
              .then(response2 => {
                if (response2.status === 200) {
                  return response2.json()
                }
                dispatch(SaveCommunityActiviesFailure())
                reject()
                return null
              })
              .then(data => {
                if (data) {
                  resolve()
                  dispatch(SaveCommunityActiviesSuccess(data))
                }
              })
              .catch(e => {
                dispatch(SaveCommunityActiviesFailure(e))
                reject()
              })
          } else {
            dispatch(SaveCommunityActiviesFailure())
            reject()
          }
        })
        .catch(e => {
          dispatch(SaveCommunityActiviesFailure(e))
          reject(e)
        })
    })
  }
}

export const saveMyGoals = (token, planId, goals) => {
  return dispatch => {
    dispatch(SaveMyGoalsBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/user/plans/my-goal/${planId}/`, {
        method: "PUT",
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(goals)
      })
        .then(response => {
          if (response.status === 200) {
            fetchMyGoals(token, planId)
              .then(response2 => {
                if (response2.status === 200) {
                  return response2.json()
                }
                dispatch(SaveMyGoalsFailure())
                reject()
                return null
              })
              .then(data => {
                if (data) {
                  resolve(data.goal)
                  dispatch(SaveMyGoalsSuccess({ goal: data.goal }))
                }
              })
              .catch(e => {
                dispatch(SaveMyGoalsFailure(e))
                reject()
              })
          } else {
            dispatch(SaveMyGoalsFailure())
            reject()
          }
        })
        .catch(e => {
          dispatch(SaveMyGoalsFailure(e))
          reject(e)
        })
    })
  }
}

export const saveRequiredServices = (
  token,
  planId,
  service,
  type,
  serviceId
) => {
  return dispatch => {
    dispatch(SaveRequiredServicesBegin())

    let method
    let url

    if (type === "edit") {
      method = "PUT"
      url = `${configs.api.base}/api/user/plan/unclassified-notes/activities/${serviceId}/`
    } else if (type === "add") {
      method = "POST"
      url = `${configs.api.base}/api/user/plan/unclassified-notes/${planId}/`
    }

    return new Promise((resolve, reject) => {
      fetch(url, {
        method,
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(service)
      })
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            fetchRequiredServices(token, planId)
              .then(response2 => {
                if (response2.status === 200) {
                  return response2.json()
                }
                dispatch(SaveRequiredServicesFailure())
                reject()
                return null
              })
              .then(data => {
                if (data) {
                  resolve()
                  dispatch(SaveRequiredServicesSuccess(data.unclassified_note))
                }
              })
              .catch(e => {
                dispatch(SaveRequiredServicesFailure(e))
                reject()
              })
          } else {
            dispatch(SaveRequiredServicesFailure())
            reject()
          }
        })
        .catch(e => {
          dispatch(SaveRequiredServicesFailure(e))
          reject(e)
        })
    })
  }
}

export const deleteSupportTeam = (token, memberId, planId) => {
  return dispatch => {
    dispatch(DeleteSupportTeamBegin())

    return new Promise((resolve, reject) => {
      fetch(
        `${configs.api.base}/api/participant/plans/guardians/${memberId}/`,
        {
          method: "DELETE",
          headers: new Headers({
            Authorization: `Bearer ${token}`
          })
        }
      )
        .then(response => {
          if (response.status === 200) {
            fetchSupportTeam(token, planId)
              .then(response2 => {
                if (response2.status === 200) {
                  return response2.json()
                }
                dispatch(DeleteSupportTeamFailure())
                reject()
                return null
              })
              .then(message => {
                if (message) {
                  resolve()
                  dispatch(DeleteSupportTeamSuccess(message))
                }
              })
              .catch(e => {
                dispatch(DeleteSupportTeamFailure(e))
                reject()
              })
          } else {
            dispatch(DeleteSupportTeamFailure())
            reject()
          }
        })
        .catch(e => {
          dispatch(DeleteSupportTeamFailure(e))
          reject(e)
        })
    })
  }
}

export const deleteRequiredServices = (token, planId, serviceId) => {
  return dispatch => {
    dispatch(DeleteRequiredServicesBegin())

    return new Promise((resolve, reject) => {
      fetch(
        `${configs.api.base}/api/user/plan/unclassified-notes/activities/${serviceId}/`,
        {
          method: "DELETE",
          headers: new Headers({
            Authorization: `Bearer ${token}`
          })
        }
      )
        .then(response => {
          if (response.status === 200) {
            fetchRequiredServices(token, planId)
              .then(response2 => {
                if (response2.status === 200) {
                  return response2.json()
                }
                dispatch(DeleteRequiredServicesFailure())
                reject()
                return null
              })
              .then(data => {
                if (data) {
                  resolve()
                  dispatch(
                    DeleteRequiredServicesSuccess(data.unclassified_note)
                  )
                }
              })
              .catch(e => {
                dispatch(DeleteRequiredServicesFailure(e))
                reject()
              })
          } else {
            dispatch(DeleteRequiredServicesFailure())
            reject()
          }
        })
        .catch(e => {
          dispatch(DeleteRequiredServicesFailure(e))
          reject(e)
        })
    })
  }
}

export const filesUpload = (token, files) => {
  return dispatch => {
    dispatch(FileUploadBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/core/upload-document/`, {
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${token}`
        }),
        body: files
      })
        .then(response => {
          if (response.status === 200) {
            return response.json()
          }

          dispatch(FileUploadFailure())
          reject()
          return null
        })
        .then(data => {
          dispatch(FileUploadSuccess())
          resolve(data)
        })
        .catch(e => {
          dispatch(FileUploadFailure())
          reject(e)
        })
    })
  }
}

export const fileView = (token, key) => {
  return fetch(`${configs.api.base}/api/core/view-document/${key}`, {
    method: "GET",
    headers: new Headers({
      Authorization: `Bearer ${token}`
    })
  })
    .then(response => {
      if (response.status === 200) {
        return response.blob()
      }
      return null
    })
    .then(blob => {
      const url = window.URL.createObjectURL(blob)
      window.open(url)
    })
}

export const downloadPlan = (token, planId) => {
  const windowReference = window.open();

  return fetch(`${configs.api.base}/api/user/plans/${planId}/export-word/`, {
    method: "GET",
    headers: new Headers({
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    }),
  })
    .then(response => {
      if (response.status === 200) {
        return response.blob()
      }
      return null
    })
    .then(blob => {
      console.log(blob);

      if (blob) {
        const url = window.URL.createObjectURL(blob)
        //window.open(url)
        windowReference.location = url
      }
    })
}

export const saveSupportRequest = (token, message, type) => {
  return dispatch => {
    dispatch(SaveSupportRequestBegin())

    return new Promise((resolve, reject) => {
      let responseStatus
      let url
      let body

      if (type === "guardian") {
        url = `${configs.api.base}/api/plan/help/suggestions/`
        body = {
          plan: message.plan,
          title: message.title,
          problem: message.problem,
          content: message.content,
          plan_section: message.planSection,
          entity_id: message.planSubsection
        }
      } else if (type === "participant") {
        url = `${configs.api.base}/api/plan/help/`
        body = {
          guardians: message.guardians,
          content: message.content,
          plan_section: message.planSection,
          entity_id: message.planSubsection
        }
      }

      fetch(url, {
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify(body)
      })
        .then(response => {
          responseStatus = response.status

          return response.json()
        })
        .then(data => {
          if (responseStatus === 201) {
            dispatch(SaveSupportRequestSuccess(data))
            resolve(data)
          } else {
            dispatch(SaveSupportRequestFailure(data))
            reject(data)
          }
        })
        .catch(e => {
          dispatch(SaveSupportRequestFailure(e))
          reject(e)
        })
    })
  }
}

export const fetchSupportRequests = (token, sectionCode, planId, filter) => {
  return dispatch => {
    dispatch(FetchSupportRequestBegin())

    return new Promise((resolve, reject) => {
      fetch(
        `${configs.api.base}/api/plan/${planId}/help/suggestions/${sectionCode}/?order_by=${filter}`,
        {
          method: "GET",
          headers: new Headers({
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          })
        }
      )
        .then(response => {
          if (response.status === 200) {
            return response.json()
          }

          dispatch(FetchSupportRequestFailure())
          reject()
          return null
        })
        .then(data => {
          dispatch(FetchSupportRequestSuccess(data))
          resolve(data)
        })
        .catch(e => {
          dispatch(FetchSupportRequestFailure(e))
          reject(e)
        })
    })
  }
}

export const toggleEndorsement = (token, suggestionId) => {
  return dispatch => {
    dispatch(ToggleEndorsementBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/plan/endorse/`, {
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify({ suggestion: { id: suggestionId } })
      })
        .then(response => {
          if (response.status === 200 || response.status === 202) {
            resolve()
            dispatch(ToggleEndorsementSuccess())
          } else {
            dispatch(ToggleEndorsementFailure())
            reject()
          }
        })
        .catch(e => {
          dispatch(ToggleEndorsementFailure(e))
          reject(e)
        })
    })
  }
}

export const archiveSuggestions = (token, obj) => {
  return dispatch => {
    dispatch(ArchiveSuggestionsBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/plan/help/resolve/`, {
        method: "POST",
        headers: new Headers({
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }),
        body: JSON.stringify({
          help_request: { id: obj.id },
          message: "may-not-be-blank",
          plan_section: obj.planSection,
          plan_subsection: null
        })
      })
        .then(response => {
          if (response.status === 200) {
            resolve()
            dispatch(ArchiveSuggestionsSuccess())
          } else {
            dispatch(ArchiveSuggestionsFailure())
            reject()
          }
        })
        .catch(e => {
          dispatch(ArchiveSuggestionsFailure(e))
          reject(e)
        })
    })
  }
}
